import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from 'constants/registrationStep';

/**
 * APIキーテンプレート更新画面の状態
 */
interface EditState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中のAPIキーテンプレート */
  selected: ApiKeyTemplate | null;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** 基本情報の更新確認モーダルの表示状態 */
  isOpenModalEdit: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * APIキーテンプレート更新画面の初期状態
 */
const initialState: EditState = {
  step: REGISTRATION_STEP.INPUT,
  loading: false,
  selected: null,
  isOpenModalDelete: false,
  isOpenModalEdit: false,
};

/**
 * APIキーテンプレート更新画面の slice(reducer + action)
 */
export const editSlice = createSlice({
  name: 'editApiKeyTemplate',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (
      state,
      { payload }: PayloadAction<EditState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateIsOpenModalEditDetail: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => ({
      ...state,
      isOpenModalEditDetail: payload,
    }),
    fetchApiKeyTemplateDetailSuccess: (
      state,
      action: PayloadAction<{
        apiKeyTemplate: ApiKeyTemplate;
      }>,
    ) => {
      const { apiKeyTemplate } = action.payload;
      state.selected = apiKeyTemplate;
      /* 確認用 */
      /* state.selected = {
        id: apiKeyTemplate.id,
        name: apiKeyTemplate.name,
        template: apiKeyTemplate.template,
        clawlers: [
          {
            id: 1,
            name: 'crowlername1',
            imageName: 'test',
            apiKeyTemplateId: 0,
          },
          {
            id: 2,
            name: 'crowlername2',
            imageName: 'test2',
            apiKeyTemplateId: 0,
          },
        ],
      }; */
    },
  },
});

/**
 * APIキーテンプレート更新画面の action
 */
export const editActions = editSlice.actions;

/**
 * APIキーテンプレート更新画面の selectors
 */
export const editSelectors = {
  selectedApiKeyTemplate: (state: RootState) =>
    state.apiKeyTemplate.edit.selected,
  isOpenModalDelete: (state: RootState) =>
    state.apiKeyTemplate.edit.isOpenModalDelete,
  isOpenModalEdit: (state: RootState) =>
    state.apiKeyTemplate.edit.isOpenModalEdit,
  currentModalStep: (state: RootState) =>
    state.apiKeyTemplate.registration.step,
} as const;
